import { ChangeDetectionStrategy, Component } from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {MdbSidenavModule} from "mdb-angular-ui-kit/sidenav";
import {MdbRippleModule} from "mdb-angular-ui-kit/ripple";
import {MdbCollapseModule} from "mdb-angular-ui-kit/collapse";
import {TranslateModule} from "@ngx-translate/core";
import {SidenavComponent} from "./sidenav/sidenav.component";

@Component({
  selector: 'app-main',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    MdbSidenavModule,
    MdbRippleModule,
    MdbCollapseModule,
    TranslateModule,
    SidenavComponent
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {
}
